import React, { useEffect, useState, useRef } from 'react';
import Compressor from 'compressorjs';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { InView } from 'react-intersection-observer';
import Toast from '../../../atoms/Toast';
import Rating from '../../../atoms/Rating';
import Dialog from '../../../molecules/Dialog';
import styles from './index.pcss';
import HalfCardHeader from './HalfCardHeader';
import WebCamera from './WebCamera';
import { getCookie } from '../../../../components/common/Cookie';
import RatingFeedBackQA from '../../../molecules/RatingFeedBackQA';
import {
  fetchRatingByUser,
  fetchUnratedRatingProducts,
  fetchUserFeedback,
  fetchQuestions,
  submitPhotoReview,
  deleteImageReview
} from '../../../../actions/ratings';
import {
  getFeedBackQuestions,
  getEditFeedBackQuestions,
  getUserRatingData
} from '../../../../refresh/selectors/ratingSelector';
import { gtmEventPush, segmentEventPush } from './../../../../modules/ga/GTMdatalayer';
import { ModalDataType, QuestionType } from '../types';
import { hideModal } from '../../../../actions/modal';
import { getProperty } from './../../../../modules/ajio-util/properties';
import { getTermNCon } from '../../../../Flags/selectors';
import {
  getPrivacyPolicy,
  getEnableReviewFlag,
  getFileSize,
  getUserConsent,
  getShowReviewProdBtn
} from '../../../selectors/featureFlagsSelector';
import { getCurrentStore } from '../../../selectors/metaData';
import { FLEEK_STORE_NAME } from '../../../../fleek/utils/constants';

type QuestionArrayType = QuestionType[];
interface RatingHalfCardContentProps {
  modalData: ModalDataType;
  productRating: number;
  goToFeedBackPage: () => void;
  retryClickHandler: () => void;
  fetchRatingByUser: ({}) => void;
  questions: QuestionArrayType;
  fetchUnratedRatingProducts: ({}) => void;
  fetchQuestions: ({}) => void;
  fetchUserFeedback: ({}) => void;
  hideModal: () => void;
  updateModal: (modalName: string, {}) => void;
  questionsFromEditFeedBack: QuestionArrayType;
  closeModal: (modalName: string) => void;
  submitPhotoReview: ({}) => void;
  deleteImageReview: ({}) => void;
  currentStore?: string;
}

interface SelectedOptionsType {
  [key: string]: number;
}

interface selectedQATextType {
  [key: string]: {
    question: string;
    option: string;
    title: string;
    questionId: number;
    subQuestionText: string;
    subResponseId: number;
  };
}

const cx = classNames.bind(styles);
import FallbackableImage from '../../../molecules/FallbackableImage';
import { replaceWithJioCDN } from '../../../../utils/imageHandling';

const RatingHalfCardContent = (props: RatingHalfCardContentProps) => {
  const {
    modalData,
    productRating = 0,
    goToFeedBackPage,
    retryClickHandler,
    fetchRatingByUser,
    questions = [],
    fetchUnratedRatingProducts,
    fetchQuestions,
    fetchUserFeedback,
    hideModal,
    updateModal,
    questionsFromEditFeedBack,
    closeModal,
    submitPhotoReview,
    deleteImageReview,
    termsConditions,
    privacyPolicy,
    enableReview,
    showReviewProdBtn,
    fileSizeCompression,
    userConsent,
    currentStore,
    setReviewAndImageIds = () => {}
  } = props;
  const {
    productDetails,
    isFeedBackSubmitted = true,
    isfromWriteFeedBack = false,
    fetchSubRatingQuestion = true,
    fetchAggRating = false,
    displayFeedBackPage,
    isFromPDP = false,
    sourcePage = '',
    pageName = '',
    pageType = '',
    isEditFeedBack = false,
    editFeedBackData = [],
    categoryID = '',
    ratingChangeHandler,
    FeedBackSubmitFailedHandler,
    editFlowQuestions = [],
    onCloseCallback,
    updateSubRating,
    reviewData = {},
    updateReviewData,
    isFromHomeWishList = false,
    isFromFirstFeedBack = false,
    isFromODP = false
  } = modalData;
  const {
    brandName = '',
    description = '',
    imageUrl = '',
    productCode = '',
    optionCode = '',
    skuId = '',
    brickCode = '',
    orderId = ''
  } = productDetails || {};
  console.log('================', props);
  const [questionWithOptions, setQuestionWithOptions] = useState<QuestionArrayType>([]);
  const [selectedOptions, setSelectedOptions] = useState<SelectedOptionsType>({});
  const [productRatingValue, setProductRatingValue] = useState(productRating);
  const [apiCallToFetchQuestion, setApiCallToFetchQuestion] = useState(isEditFeedBack);
  const [selectedQAText, setSelectedQAText] = useState<selectedQATextType>({});
  const [cameraDialog, setCameraDialog] = useState(false);
  const fileInputRef = useRef(null);
  const [imageSource, setImageSource] = useState([]);
  const [cameraOpen, setCameraOpen] = useState(false);
  const [text, setText] = useState('');
  const [progress, setProgress] = useState(0);
  const [imagesMeta, setImagesMeta] = useState([]);
  const [reviewError, setReviewError] = useState<string | null>(null);
  const [fileTypeError, setFileTypeError] = useState(null);
  const [uploadFailedError, setUploadFailedError] = useState(null);
  const maxLength = 500;
  const [retryUpload, setRetryUpload] = useState([]);
  const [tellMeMore, setTellMeMore] = useState(false);
  const [reviewId, setReviewId] = useState(null);
  const [progressLoading, setProgressLoading] = useState([]);
  function handleChange(event) {
    const { value } = event.target;
    setText(value.slice(0, maxLength));
    setReviewError(null);
  }

  useEffect(() => {
    if (isEditFeedBack && enableReview) {
      const { reviewText = '', reviewId = '' } = reviewData;
      setText(reviewText);
      let imgSrc = [];
      const updateImagesMeta = [];
      reviewData?.imageMap?.largeSize?.map((item, index) => {
        const reviewObj = {
          index: index,
          imageId: item.imageId,
          reviewId: reviewId,
          imageUrl: item.imageUrl,
          imageStatus: item.imageStatus,
          imageStatusReason: item.imageStatusReason
        };
        imgSrc.push(item.imageUrl);
        updateImagesMeta.push(reviewObj);
      });
      setImagesMeta([...updateImagesMeta]);
      setImageSource(imgSrc);
    }
  }, [isEditFeedBack]);

  useEffect(() => {
    if ((isFromHomeWishList && enableReview) || (isFromODP && enableReview)) {
      setTellMeMore(true);
    }
  }, [isFromHomeWishList]);

  useEffect(() => {
    if (!isEditFeedBack) {
      setQuestionWithOptions(questions);
    }
  }, [questions, isEditFeedBack]);

  useEffect(() => {
    if (
      isEditFeedBack &&
      questionsFromEditFeedBack.length === 0 &&
      apiCallToFetchQuestion &&
      sourcePage !== 'ORDER_DETAILS'
    ) {
      (async () => {
        const response = await fetchQuestions({ categoryID });
        setApiCallToFetchQuestion(false);
      })();
    }
  }, [isEditFeedBack, questionsFromEditFeedBack, apiCallToFetchQuestion, sourcePage]);

  useEffect(() => {
    if (sourcePage === 'ORDER_DETAILS' && editFlowQuestions.length > 0 && isEditFeedBack) {
      setQuestionWithOptions(editFlowQuestions);
    }
  }, [isEditFeedBack, editFlowQuestions, sourcePage]);

  useEffect(() => {
    if (questionsFromEditFeedBack.length > 0 && isEditFeedBack && sourcePage !== 'ORDER_DETAILS') {
      setQuestionWithOptions(questionsFromEditFeedBack);
    }
  }, [isEditFeedBack, questionsFromEditFeedBack, sourcePage]);

  useEffect(() => {
    if (isEditFeedBack && editFeedBackData.length > 0) {
      const selectedOptionsObject = {};
      editFeedBackData.map(
        ({ questionId, subResponseId }: { questionId: number; subResponseId: number }) => {
          selectedOptionsObject[`${questionId}`] = subResponseId;
        }
      );
      setSelectedOptions(selectedOptionsObject);
    }
  }, [isEditFeedBack, editFeedBackData]);

  useEffect(() => {
    if (editFlowQuestions.length > 0 && isEditFeedBack && editFeedBackData.length > 0) {
      const selectedQATextObject = {};
      editFeedBackData.map(
        ({ questionId, subResponseId }: { questionId: number; subResponseId: number }) => {
          const question = editFlowQuestions?.find(question => question.questionId === questionId);
          const selectedOptionText = question?.responseOptions?.find(
            response => response.id === subResponseId
          );
          selectedQATextObject[`${questionId}`] = {
            question: question?.title,
            option: selectedOptionText?.text,
            title: question?.title,
            questionId: questionId,
            subQuestionText: selectedOptionText?.text,
            subResponseId: subResponseId
          };
        }
      );
      setSelectedQAText(selectedQATextObject);
    }
  }, [isEditFeedBack, editFeedBackData, editFlowQuestions]);

  useEffect(() => {
    setReviewAndImageIds(imagesMeta);
  }, [imagesMeta]);

  const optionSelectionHandler = (selectedOption, questionId) => {
    setSelectedOptions(initial => {
      return {
        ...initial,
        [questionId]: selectedOption
      };
    });
    const question = questionWithOptions?.find(question => question.questionId === questionId);
    const selectedOptionText = question?.responseOptions?.find(
      response => response.id === selectedOption
    );
    setSelectedQAText(initial => {
      return {
        ...initial,
        [questionId]: {
          question: question?.title || '',
          option: selectedOptionText?.text || '',
          title: question?.title,
          questionId: questionId,
          subQuestionText: selectedOptionText?.text || '',
          subResponseId: selectedOption
        }
      };
    });
  };

  const onSubmitClickHandler = async () => {
    const isReviewText = text?.length > 0 ? 'text' : null;
    const isImage = imagesMeta?.length > 0 ? 'img' : null;
    let submitResponse = null;
    if (text?.length === 0 && imagesMeta?.length > 0) {
      setReviewError('Please write your review before submitting');
      return;
    } else {
      const requestArray = Object.keys(selectedOptions)
        .map(key => {
          return {
            optionCode: optionCode.length !== 0 ? optionCode : skuId,
            productCode: productCode.length !== 0 ? productCode : skuId,
            questionId: +key,
            skuId: skuId,
            subResponseId: selectedOptions[key]
          };
        })
        .filter(object => object.subResponseId !== -1);
      const { questionText = '', selectedOptionsText = '' } = Object.values(selectedQAText).reduce(
        (cumulative: { questionText: string; selectedOptionsText: string }, current) => {
          return {
            questionText: cumulative.questionText + current?.question + ',',
            selectedOptionsText: cumulative.selectedOptionsText + current?.option + ','
          };
        },
        { questionText: '', selectedOptionsText: '' }
      );
      const isSubRating = selectedOptionsText ? 'sub' : null;
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews & ratings interactions',
        event_action: `SR - Success|${questionText.substring(0, 100)}`,
        event_label: `submit | ${selectedOptionsText} ${isSubRating ? ', sub' : ''} ${
          isImage ? ', img' : ''
        } ${isReviewText ? ', text' : ''}`,
        ...(orderId.length > 0 && { order_id: orderId }),
        product_id: skuId,
        product_name: description,
        ...(brickCode.length > 0 && { product_brick: brickCode }),
        page_name: pageName,
        page_type: pageType,
        store_type: 'ajio'
      });

      segmentEventPush({
        event: 'Sub Ratings Collected',        
        order_id: orderId,
        product_id: skuId,
        product_name: description,
        review_image_count: imagesMeta?.length,
        review_text: text,
        screen_name: pageName,
        sub_rating_value: selectedOptionsText
      })

      // gtmEventPush({
      //   event: 'reviews_rating_interactions',
      //   event_category: 'reviews_rating_interactions',
      //   event_action: 'Submit Review - Success',
      //   event_label: `${isSubRating},${isReviewText},${isImage}`,
      //   ...(orderId.length > 0 && { order_id: orderId }),
      //   product_id: skuId,
      //   product_name: description,
      //   ...(brickCode.length > 0 && { product_brick: brickCode }),
      //   page_name: pageName,
      //   page_type: pageType,
      //   store_type: 'ajio'
      // });
      const updatedQA = Object.values(selectedQAText);
      const responseOfFeedBackSubmit = await fetchUserFeedback(requestArray);
      if (responseOfFeedBackSubmit?.statusCode === 200) {
        updateSubRating && updateSubRating(updatedQA);
        if (!isFromPDP && sourcePage !== 'LP' && sourcePage !== 'Wishlist') {
          await fetchUnratedRatingProducts({});
        }
        onCloseCallback && onCloseCallback();
        goToFeedBackPage();
      } else {
        FeedBackSubmitFailedHandler && FeedBackSubmitFailedHandler();
        hideModal();
      }
      if (enableReview) {
        if (imagesMeta && imagesMeta?.length > 0 && text?.length > 0) {
          const reqObj = {
            skuId,
            optionCode,
            reviewText: text
          };
          submitResponse = await apiCall(reqObj, null);
        } else if (text?.length === 0 && imagesMeta?.length > 0) {
          setReviewError('Please write your review before submitting');
        } else if (imagesMeta?.length === 0 && text?.length > 0) {
          const reqObj = {
            skuId,
            optionCode,
            reviewText: text
          };
          // gtmEventPush({
          //   event: 'reviews_rating_interactions',
          //   event_category: 'reviews_rating_interactions',
          //   event_action: 'Submit Review - Success',
          //   event_label: `${isSubRating},${isReviewText}`,
          //   ...(orderId.length > 0 && { order_id: orderId }),
          //   product_id: skuId,
          //   product_name: description,
          //   ...(brickCode.length > 0 && { product_brick: brickCode }),
          //   page_name: pageName,
          //   page_type: pageType,
          //   store_type: 'ajio'
          // });
          submitResponse = await apiCall(reqObj, null);
        } else if (imagesMeta.length === 0 && text.length === 0) {
          // gtmEventPush({
          //   event: 'reviews_rating_interactions',
          //   event_category: 'reviews_rating_interactions',
          //   event_action: 'Submit Review - Success',
          //   event_label: `${isSubRating}`,
          //   ...(orderId.length > 0 && { order_id: orderId }),
          //   product_id: skuId,
          //   product_name: description,
          //   ...(brickCode.length > 0 && { product_brick: brickCode }),
          //   page_name: pageName,
          //   page_type: pageType,
          //   store_type: 'ajio'
          // });
        }
        if (!submitResponse || submitResponse?.statusCode === 200) {
          var userName = getCookie('un');
          if (isFromFirstFeedBack && updateReviewData) {
            const updatedReview = {};
            updatedReview.reviewId = submitResponse?.reviewId;
            updatedReview.reviewText = text;
            updatedReview.reviewStatus = 'UNDER MODERATION';
            updatedReview.reviewerName = userName ? userName : '';
            updatedReview.createdDate = Date.now();
            updatedReview.imageMap = {};
            let updatedThumbnailArray = [];
            let updatedLargeArray = [];
            imagesMeta &&
              imagesMeta.length > 0 &&
              imagesMeta.map(item => {
                const thumbnailObj = {
                  imageId: item.imageId,
                  imageUrl: item.imageUrl,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason,
                  parentImageId: item.parentImageId
                };
                const largeObj = {
                  imageId: item.imageId,
                  imageUrl: item.imageUrl,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason
                };
                updatedThumbnailArray.push(thumbnailObj);
                updatedLargeArray.push(largeObj);
              });
            updatedReview.imageMap.thumbnail = updatedThumbnailArray;
            updatedReview.imageMap.largeSize = updatedLargeArray;
            updateReviewData(updatedReview);
          }
          if (isEditFeedBack && updateReviewData) {
            const updatedReview = { ...reviewData };
            updatedReview.reviewStatus = 'UNDER MODERATION';
            updatedReview.reviewText = text;
            updatedReview.imageMap = {};
            let updatedThumbnailArray = [];
            let updatedLargeArray = [];
            imagesMeta &&
              imagesMeta.length > 0 &&
              imagesMeta.map(item => {
                const thumbnailObj = {
                  imageId: item.imageId,
                  imageUrl: item.imageUrl,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason,
                  parentImageId: item.parentImageId
                };
                const largeObj = {
                  imageId: item.imageId,
                  imageUrl: item.imageUrl,
                  imageStatus: item.imageStatus,
                  imageStatusReason: item.imageStatusReason
                };
                updatedThumbnailArray.push(thumbnailObj);
                updatedLargeArray.push(largeObj);
              });
            updatedReview.imageMap.thumbnail = updatedThumbnailArray;
            updatedReview.imageMap.largeSize = updatedLargeArray;
            updateReviewData(updatedReview);
          }
        } else {
          FeedBackSubmitFailedHandler && FeedBackSubmitFailedHandler();
          hideModal();
        }
      }
    }
  };

  const onSkipHandler = () => {
    const questions = questionWithOptions.reduce((accumulator, current) => {
      return accumulator + current.title + ',';
    }, '');

    const isNewFlow = enableReview && showReviewProdBtn;

    if (!isNewFlow) {
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews & ratings interactions',
        event_action: questions.length > 100 ? questions.substring(0, 100) : questions,
        event_label: 'skip / cross',
        ...(orderId.length > 0 && { order_id: orderId }),
        product_id: skuId,
        product_name: description,
        ...(brickCode.length > 0 && { product_brick: brickCode }),
        page_name: pageName,
        page_type: pageType,
        store_type: 'ajio'
      });
    }

    if (isNewFlow) {
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: questions.substring(0, 100),
        event_label: 'SR - Skip',
        ...(orderId.length > 0 && { order_id: orderId }),
        product_id: skuId,
        ...(brickCode.length > 0 && { product_brick: brickCode }),
        page_name: pageName,
        product_name: description,
        page_type: pageType,
        store_type: 'ajio'
      });
    }

    onCloseCallback && onCloseCallback();
    closeModal('rating-halfcard');
  };

  const handleGA = (label) => {
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'Add a Review',
      event_label: label,
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      product_name: description,
      page_type: pageType,
      store_type: 'ajio'
    });
  };

  const onSkipWriteAReview = () => {
    handleGA('skip');
    onCloseCallback && onCloseCallback();
    closeModal('rating-halfcard');
  };

  const onHandleWriteReview = () => {
    handleGA('write a review');
    setTellMeMore(false);
  };

  const ratingClickHandler = async (rating: number) => {
    const response = await fetchRatingByUser({
      sourcePage: sourcePage,
      skuData: skuId,
      rating: rating,
      fetchSubRatingQuestion: fetchSubRatingQuestion,
      fetchAggRating: fetchAggRating
    });
    console.log('RESPONSE', response);
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      product_name: description,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      page_type: pageType,
      store_type: 'ajio'
    });

    // segment push event
    segmentEventPush({
      event: 'Ratings Collected',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      //event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      // ...(brickCode.length > 0 && { product_brick: brickCode }),
      products:[{
        product_id: skuId,
        product_name: description,
      }],    
      rating_value: rating,
      screen_name: pageName,
      // page_type: pageType,
      store_type: 'ajio'
    });
    if (response?.statusCode === 200) {
      setProductRatingValue(rating);
      ratingChangeHandler && ratingChangeHandler(rating);
      updateModal('rating-halfcard', {
        state: {
          ...modalData,
          isfromWriteFeedBack: false,
          isFeedBackSubmitted: true
        }
      });
      if (!(isEditFeedBack || isFromFirstFeedBack) && enableReview) {
        setTellMeMore(true);
      }
    }
    if (response?.statusCode !== 200) {
      updateModal('rating-halfcard', {
        state: {
          ...modalData,
          rating: 0,
          isfromWriteFeedBack: false,
          isFeedBackSubmitted: false
        }
      });
    }
  };

  const openCameraDialog = () => {
    setCameraDialog(!cameraDialog);
  };

  const toggleImageGallery = () => {
    if (fileInputRef) {
      fileInputRef?.current?.click();
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: 'Add a photo',
        event_label: 'select from gallery',
        ...(orderId.length > 0 && { order_id: orderId }),
        product_id: skuId,
        ...(brickCode.length > 0 && { product_brick: brickCode }),
        page_name: pageName,
        product_name: description,
        page_type: pageType,
        store_type: 'ajio'
      });
    }
  };

  const toggleImageCamera = () => {
    setCameraOpen(true);
    openCameraDialog();
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'Add a photo',
      event_label: 'click a photo',
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      product_name: description,
      page_type: pageType,
      store_type: 'ajio'
    });
  };

  const compressFile = file => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6, // Set the image quality to 60%
        success(result) {
          resolve(result); // Resolve the Promise with the compressed file
        },
        error(err) {
          reject(err); // Reject the Promise with the error message
        }
      });
    });
  };

  const handleFileUpload = async event => {
    const file = event.target.files[0];
    var compressedFile = file;
    const fileType = file.type;
    const fileSize = file.size;
    if (fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/jpg') {
      if (fileSize > fileSizeCompression) {
        //1.5MB check
        compressedFile = await compressFile(file);
      }
      const reader = new FileReader();
      reader.readAsDataURL(compressedFile);
      reader.onloadend = () => {
        const imgArr = imageSource;
        setProgressLoading(prev => [
          ...prev,
          { loader: 'progress_bar', loadingIndex: imgArr.length }
        ]);
        imgArr.push(reader.result);
        openCameraDialog();
        setImageSource(imgArr);
        const base64data = reader.result;
        const reqObj = {
          files: base64data,
          skuId,
          reviewText: ''
        };
        apiCall(reqObj, null);
      };
    } else {
      setFileTypeError('file type is not jpeg, png, or jpg');
      openCameraDialog();
    }
  };

  const removeImage = async index => {
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'Add a photo',
      event_label: 'image upload cancel',
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      product_name: description,
      page_type: pageType,
      store_type: 'ajio'
    });
    const removedImage = imageSource[index];
    const updatedImageSource = imageSource.slice(0, index).concat(imageSource.slice(index + 1));
    setImageSource(updatedImageSource);
    const filteredMeta =
      imagesMeta && imagesMeta.length > 0 ? imagesMeta.filter(ele => ele.index === index) : null;
    if (filteredMeta) {
      const imageId = filteredMeta[0].imageId;
      const reviewId = filteredMeta[0].reviewId;
      const reqObj = {
        imageId,
        reviewId
      };
      const response = await deleteImageReview(reqObj);
      if (response?.statusCode !== 200) {
        setImageSource(prevItems => {
          prevItems.splice(index, 0, removedImage);
          return [...prevItems];
        });
      }
      if (response?.statusCode === 200 && response?.response?.message) {
        let updateRetry = [...retryUpload];
        for (let i = 0; i < updateRetry.length; i++) {
          if (updateRetry[i] > index) {
            updateRetry[i] -= 1;
          }
        }
        setRetryUpload(updateRetry);
        const updatedImagesMetaFiltered = imagesMeta.filter(item => item.index !== index); // Filter out the item to remove
        const updatedImagesMeta = updatedImagesMetaFiltered.map((item, idx) => {
          return {
            ...item,
            index: idx
          };
        });
        setImagesMeta(updatedImagesMeta);
      }
    }
  };

  const onTakePhoto = async data => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onloadend = () => {
      const compressedBase64 = reader.result;
      setCameraOpen(false);
      const imgArr = imageSource;
      imgArr.push(compressedBase64);
      setImageSource(imgArr);
      const reqObj = {
        files: compressedBase64,
        skuId,
        reviewText: ''
      };
      apiCall(reqObj, null);
    };
  };

  const setProgressLoader = (index, loaderState) => {
    setProgressLoading(prevItems => {
      return prevItems?.map(item => {
        if (item?.loadingIndex === index) {
          return {
            ...item,
            loader: loaderState
          };
        }
        return item;
      });
    });
  };

  const retryImageUpload = index => {
    const updatedRetry = retryUpload.filter(item => item !== index);
    if (updatedRetry && updatedRetry.length === 0) {
      setUploadFailedError(null);
    }
    setProgressLoader(index, 'progress_bar');
    setRetryUpload(updatedRetry);
    const imageData = imageSource[index];
    const reqObj = {
      files: imageData,
      skuId,
      reviewText: ''
    };
    apiCall(reqObj, index);
  };

  const apiCall = async (reqObj: Object, index: Any) => {
    const handleFailures = () => {
      if (index) {
        const updateRetry = [...retryUpload];
        updateRetry.push(index);
        setRetryUpload(updateRetry);
      } else {
        if (imageSource && imageSource.length > 0) {
          const latestIndex = imageSource.length - 1;
          const updateRetry = [...retryUpload];
          updateRetry.push(latestIndex);
          setRetryUpload(updateRetry);
          setUploadFailedError('One or more photos were not uploaded. Please try again.');
        }
      }
      const retObj = {
        statusCode: 400,
        reviewId: null
      };
      return retObj;
    }


    try {
      setTimeout(
        () => setProgressLoader(index || imageSource.length - 1, 'progress_bar half'),
        200
      );
      const resp = await submitPhotoReview(reqObj, false);
      if (resp?.response && resp?.response?.reviewId && resp.statusCode === 200) {
        const apiResp = resp.response;
        const latestIndex = imageSource.length - 1;
        if (resp?.response?.imageIds.length === 1) {
          const reviewObj = {
            index: index || latestIndex,
            imageId: apiResp.imageIds[0],
            reviewId: apiResp.reviewId,
            imageUrl: imageSource[index || latestIndex],
            imageStatus: '',
            imageStatusReason: '',
            parentImageId: apiResp.imageIds[0]
          };

          setImagesMeta([...imagesMeta, reviewObj]);
          gtmEventPush({
            event: 'reviews_rating_interactions',
            event_category: 'reviews_rating_interactions',
            event_action: 'Add a photo',
            event_label: 'image upload success',
            ...(orderId.length > 0 && { order_id: orderId }),
            product_id: skuId,
            ...(brickCode.length > 0 && { product_brick: brickCode }),
            page_name: pageName,
            product_name: description,
            page_type: pageType,
            store_type: 'ajio'
          });
        }

        setProgressLoader(index || imageSource.length - 1, 'progress_bar full');
        setReviewId(apiResp.reviewId);
        setTimeout(() => setProgressLoader(index || imageSource.length - 1, ''), 200);

        const retObj = {
          statusCode: 200,
          reviewId: apiResp.reviewId
        };
        return retObj;
      }
      // retry upload
      handleFailures();
      setProgressLoader(index || imageSource.length - 1, '');
    } catch (error) {
      handleFailures();
      setProgressLoader(index || imageSource.length - 1, '');
    }
  };

  const triggerImpresion = inView => {
    return;
    if (inView) {
      gtmEventPush({
        event: 'reviews_rating_interactions',
        event_category: 'reviews_rating_interactions',
        event_action: 'Add a Review',
        event_label: 'skip / submit',
        ...(orderId.length > 0 && { order_id: orderId }),
        product_id: skuId,
        ...(brickCode.length > 0 && { product_brick: brickCode }),
        page_name: pageName,
        product_name: description,
        page_type: pageType,
        store_type: 'ajio'
      });
    }
  };

  const isFleek = currentStore === FLEEK_STORE_NAME;

  return (
    <div className={cx('half-card-container', isFleek && 'fleek-half-card-container', tellMeMore && 'expanded')}>
      <HalfCardHeader
        brandName={brandName}
        productName={description}
        feebackCard={false}
        currentStore={currentStore}
      />
      <FallbackableImage
        src={imageUrl}
        alt=''
        htmlLoading="eager"
        handleClick={() => {
          console.log('Image clicked');
        }}
        customErroredImgCls={cx('img-load-errored')}
        imageCls={cx('half-card-image')}
      />
      {isfromWriteFeedBack && (
        <div className={cx('write-feedback-container')}>
          <p className={cx('rating-feedback', 'write')}>Tap on the stars to rate your experience</p>
          <div className={cx('five-star-container')}>
            <Rating
              iconSize="lg"
              rating={productRatingValue}
              currentStore={currentStore}
              onClickHandler={rating => {
                ratingClickHandler(rating);
              }}
            />
          </div>
        </div>
      )}
      {!isfromWriteFeedBack && isFeedBackSubmitted && (
        <div className={cx('feedback-submited-container')}>
          {!isEditFeedBack && (
            <p className={cx('rating-feedback', isFleek ? 'fleek-rating-feedback' : '')}>
              Thank you for rating!
            </p>
          )}
          <div className={cx('five-star-container')}>
            <Rating
              iconSize="lg"
              rating={productRatingValue}
              currentStore={currentStore}
              onClickHandler={rating => ratingClickHandler(rating)}
            />
          </div>
          {tellMeMore && !isEditFeedBack && enableReview && (
            <div className={cx('tell-us-more-section')}>
              <div className={cx('heading', isFleek ? 'fleek-heading' : '')}>Tell Us More</div>
              <div className={cx('sub-heading', isFleek ? 'fleek-sub-heading' : '')}>
                Shoppers find your review helpful just like you do
              </div>
              <div className={cx('cta-buttons-container')}>
                <InView
                  as="div"
                  threshold={1}
                  triggerOnce={true}
                  onChange={(inView, entry) => triggerImpresion(inView)}
                >
                  <button
                    className={cx('skip-button', 'button', isFleek ? 'fleek-skip-button' : '')}
                    onClick={onSkipWriteAReview}
                  >
                    <p
                      className={cx(
                        'button-text',
                        'skip-button-text',
                        isFleek ? 'fleek-skip-button-text' : ''
                      )}
                    >
                      Skip
                    </p>
                  </button>
                  <button
                    className={cx('submit-button', 'button', isFleek ? 'fleek-submit-button' : '')}
                    onClick={onHandleWriteReview}
                  >
                    <p
                      className={cx(
                        'button-text',
                        'submit-button-text',
                        isFleek ? 'fleek-submit-button-text' : ''
                      )}
                    >
                      Write a Review
                    </p>
                  </button>
                </InView>
              </div>
            </div>
          )}
          {!tellMeMore && questionWithOptions.length > 0 && (
            <>
              <div className={cx('questions-container')}>
                {questionWithOptions.map(question => {
                  return (
                    <div key={question.questionId}>
                      <RatingFeedBackQA
                        question={question.title}
                        selected={selectedOptions[question.questionId] || ''}
                        options={question.responseOptions}
                        onClickHandler={selectedOption =>
                          optionSelectionHandler(selectedOption, question.questionId)
                        }
                        variant="mobile"
                        isFleek={isFleek}
                      />
                    </div>
                  );
                })}
                {enableReview && (
                  <div className={cx('photo-container')}>
                    <p role="heading" aria-level="3" className={cx('rating-question')}>{'Add a photo'}</p>
                    {imageSource && imageSource.length > 0 && (
                      <div>
                        <div className={cx('uploaded-image')}>
                          {imageSource &&
                            imageSource.map((imgSrc, index) => {
                              const showProgressBar = progressLoading.find(
                                el => el?.loadingIndex === index && el?.loader
                              );
                              return !retryUpload.includes(index) || showProgressBar ? (
                                <div className={cx('article-image-box')}>
                                  <div className={cx(showProgressBar ? 'image_upload-loader' : '')}>
                                    <div
                                      className={cx(
                                        showProgressBar ? showProgressBar?.loader?.split(' ') : ''
                                      )}
                                    />
                                  </div>
                                  <img className={cx('article-image')} src={replaceWithJioCDN(imgSrc)} alt="Article" />
                                  <img
                                    className={cx('article-image-cross')}
                                    src={`${getProperty('imageBaseUrl')}/static/img/imageClose.svg`}
                                    alt="Close icon"
                                    onClick={() => removeImage(index)}
                                  />
                                </div>
                              ) : (
                                <div
                                  onClick={() => retryImageUpload(index)}
                                  className={cx('article-image-box-opacity')}
                                  style={{
                                    backgroundImage: `url(${imgSrc})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center'
                                  }}
                                >
                                  <img
                                    className={cx('article-image-retry')}
                                    src={`${getProperty(
                                      'imageBaseUrl'
                                    )}/static/img/retryImageUpload.svg`}
                                    alt="Retry icon"
                                    // onClick={() => retryImageUpload(index)}
                                  />
                                </div>
                              );
                            })}
                          {imageSource && imageSource.length < 5 && (
                            <div onClick={openCameraDialog} className={cx('uploaded-image-add')}>
                              +
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {imageSource && imageSource.length === 0 && (
                      <div className={cx('image-upload')}>
                        <span className={cx('capture-image')}>
                          <img
                            src={`${getProperty('imageBaseUrl')}/static/img/cameraUpload.svg`}
                            onClick={openCameraDialog}
                            alt="Image search"
                          />
                        </span>
                        <div className={cx('image-upload-placeholder')}>
                          <span>A picture is worth a thousand words.</span>
                          <span>Share an image of the product you received.</span>
                        </div>
                      </div>
                    )}
                    {uploadFailedError && <p className={cx('review-error')}>{uploadFailedError}</p>}
                  </div>
                )}
                {enableReview && (
                  <div className={cx('review-container')}>
                    <p role="heading" aria-level="3" className={cx('rating-question')}>{'Write your review here'}</p>
                    <div className={cx('text-area')} style={{ position: 'relative' }}>
                      <div className='sr-only'>{maxLength} characters allowed</div>
                      <textarea
                        value={text}
                        onChange={handleChange}
                        maxLength={maxLength}
                        rows={7}
                        cols={30}
                        placeholder="Tell us more about your experience, product quality, material, size and fit, delivery experience and packaging."
                      />
                      <style>
                        {`
                                            textarea::placeholder {
                                                color: #202020;
                                                font-size: 10;
                                            }
                                            `}
                      </style>
                      <div style={{ position: 'absolute', bottom: 5, right: 10 }} aria-hidden={true}>
                        {text.length}/{maxLength}
                      </div>
                    </div>
                    {reviewError && <p className={cx('review-error')}>{reviewError}</p>}
                  </div>
                )}
              </div>
              {enableReview && userConsent && (
                <div className={cx('user-consent')}>
                  <span>
                    You are giving AJIO consent to publish and process personal info in accordance
                    with{' '}
                  </span>
                  <a href={termsConditions}>T&C</a>
                  <span> and </span>
                  <a href={privacyPolicy}>privacy policy</a>
                </div>
              )}
              <div className={cx('cta-buttons-container')}>
                <InView
                  as="div"
                  threshold={1}
                  triggerOnce={true}
                  onChange={(inView, entry) => triggerImpresion(inView)}
                >
                  <button
                    className={cx('skip-button', 'button', isFleek ? 'fleek-skip-button' : '')}
                    onClick={onSkipHandler}
                  >
                    <p
                      className={cx(
                        'button-text',
                        'skip-button-text',
                        isFleek ? 'fleek-skip-button-text' : ''
                      )}
                    >
                      Skip
                    </p>
                  </button>
                  <button
                    className={cx(
                      'submit-button',
                      'button',
                      isFleek ? 'fleek-submit-button' : ''
                    )}
                    onClick={onSubmitClickHandler}
                    // disabled={!Object.keys(selectedOptions).length}
                  >
                    <p
                      className={cx(
                        'button-text',
                        'submit-button-text',
                        isFleek ? 'fleek-submit-button-text' : ''
                      )}
                    >
                      Submit
                    </p>
                  </button>
                </InView>
              </div>
            </>
          )}
        </div>
      )}
      {!isfromWriteFeedBack && !isFeedBackSubmitted && (
        <div className={cx('feedback-failed-container')}>
          <div className={cx('feedback-text-container')}>
            <p className={cx('rating-feedback-failed')}>Oops! Rating Submission Failed</p>
            <p className={cx('rating-feedback-detail')}>
              This might happen due to a technical issue. Please try again
            </p>
          </div>
          <div className={cx('cta-buttons-container', 'cta-buttons-container-margin')}>
            <button className={cx('retry-button', 'button')} onClick={retryClickHandler}>
              <p className={cx('button-text', 'retry-button-text')}>Retry</p>
            </button>
          </div>
        </div>
      )}
      {cameraDialog && (
        <Dialog showDialog={cameraDialog} type="drawer" onCancel={() => openCameraDialog()} ariaLabel="Open camera or gallery">
          <div className={cx('dialog-camera')}>
            <div className={cx('upload-heading')} role="heading" aria-level={2}>Upload Image</div>
            <div className={cx('upload-sub-heading')}>You can upload upto 5 images</div>
            <div role="button" aria-haspopup={'dialog'} onClick={toggleImageCamera} className={cx('upload-from-camera')}>
              <span className={cx('camera-image')}>
                <img
                  src={`${getProperty('imageBaseUrl')}/static/img/cameraClick.svg`}
                  alt=""
                />
              </span>
              <span className={cx('camera-image-placeholder')}>Click a photo</span>
              <span className={cx('camera-arrow-image')}>
                <img
                  src={`${getProperty('imageBaseUrl')}/static/img/Chevron_Right_Transparent.svg`}
                  alt=""
                />
              </span>
            </div>
            <div role="button" aria-haspopup={'dialog'} onClick={toggleImageGallery} className={cx('upload-from-gallery')}>
              <span className={cx('camera-image')}>
                <img
                  src={`${getProperty('imageBaseUrl')}/static/img/gallerySearch.svg`}
                  alt=""
                />
              </span>
              <span className={cx('camera-image-placeholder')}>Select from Gallery</span>
              <span className={cx('camera-arrow-image')}>
                <img
                  src={`${getProperty('imageBaseUrl')}/static/img/Chevron_Right_Transparent.svg`}
                  alt=""
                />
              </span>
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
              ref={fileInputRef}
              multiple
            />
          </div>
        </Dialog>
      )}
      {cameraOpen && <WebCamera onTakePhoto={onTakePhoto} />}
      {fileTypeError && (
        <Toast message={fileTypeError} position="bottom" visibility={fileTypeError} time={3000} />
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { modalData = {} } = ownProps;
  const { productDetails = {} } = modalData;
  const { optionCode = '' } = getUserRatingData(state) || {};
  return {
    ...ownProps,
    questions: (optionCode === productDetails?.skuId && getFeedBackQuestions(state)) || [],
    questionsFromEditFeedBack: getEditFeedBackQuestions(state) || [],
    termsConditions: getTermNCon(state.flags),
    privacyPolicy: getPrivacyPolicy(state),
    enableReview: getEnableReviewFlag(state) === 'ON',
    fileSizeCompression: getFileSize(state),
    userConsent: getUserConsent(state) === 'ON',
    currentStore: getCurrentStore(state),
    showReviewProdBtn: getShowReviewProdBtn(state.flags)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchRatingByUser: (reqObj = {}) => dispatch(fetchRatingByUser(reqObj)),
    fetchUserFeedback: (reqObj = {}) => dispatch(fetchUserFeedback(reqObj)),
    fetchUnratedRatingProducts: (reqObj = []) => dispatch(fetchUnratedRatingProducts(reqObj)),
    fetchQuestions: (reqObj = []) => dispatch(fetchQuestions(reqObj)),
    closeModal: (name: string) => dispatch(hideModal(name)),
    submitPhotoReview: (reqObj = {}, showLoader: boolean) =>
      dispatch(submitPhotoReview(reqObj, showLoader)),
    deleteImageReview: (reqObj = {}) => dispatch(deleteImageReview(reqObj))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RatingHalfCardContent);
